<template>
  <v-select
    v-model="inputValue"
    :items="searchResult.items"
    :loading="loading"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    item-text="name"
    item-value="id"
  />
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: '',
    }
  },
  computed: {
    ...mapState({
      account: state => state.account.account,
    }),
    searchResult() {
      return this.$store.getters['account/searchResult']
    },
    inputValue: {
      get() {
        return this.value
      },
      set(id) {
        this.$emit('input', id)
      },
    },
  },
  mounted() {
    this.getAccountList()
  },
  methods: {
    async getAccountList() {
      this.loading = true
      try {
        await this.$store.dispatch('account/SEARCH', {
          systemOwnerId: this.account.systemOwnerId,
          pageSize: 999,
        })
        this.loading = false
      } catch (e) {
        const error = new Error('担当者の取得に失敗しました。')
        throw error
      }
    },
  },
}
</script>
